import axios from 'axios';
import { API_BASE_URL } from '../utils/helper';
import { RequestBody } from '../utils/types';

// Absolute URLs (e.g. container URLs in .env.localdevelopment) bypass the APIM base URL.
const resolveUrl = (url: string) => (/^https?:\/\//i.test(url) ? url : `${API_BASE_URL}${url}`);

const axiosApiCall = async (type: string, url: string, body?: RequestBody<object>) => {
  const fullUrl = resolveUrl(url);
  switch (type) {
    case 'GET':
      return await axios.get(fullUrl, { timeout: 15000 * 100 }).then(t => t.data);
    case 'POST':
      return await axios.post(fullUrl, body, { timeout: 15000 * 100 }).then(t => t.data);
    case 'PUT':
      return await axios.put(fullUrl, body, { timeout: 15000 * 100 }).then(t => t.data);
  }
};

export { axiosApiCall };
